export const http = {
  accountDelete: "已删除账号",
  loginExpiration: "连接超时",
  networkError: "网络错误",
  NoAccess: "无法访问",
  unknownErrorPleaseTryAgainLater: "未知错误，请稍后重试。",
  yourAccountHasBeenRemoved: "您的账号已被删除，您已被自动登出。",
  yourAccountHasLoggedInElsewhere: "您的账号目前已在其他地方登录。",
  tokenInvalid: "身份认证超时，请重新登录。",
  noOperationAccess: "没有访问权限",
  noDataAccess: "没有访问权限",
  yourAccountHasLoggedOut: "您的账号已登出，请重新登录。",
};
